import { render } from "./DiscoverAlbumWithTracks.vue?vue&type=template&id=7657c513&scoped=true"
import script from "./DiscoverAlbumWithTracks.vue?vue&type=script&lang=js"
export * from "./DiscoverAlbumWithTracks.vue?vue&type=script&lang=js"

import "./DiscoverAlbumWithTracks.vue?vue&type=style&index=0&id=7657c513&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7657c513"]])

export default __exports__